import { Dialog, DialogActions, DialogContent } from '@material-ui/core';
import * as React from 'react';
import { useDispatch } from 'react-redux';
import { getDocumentHelper } from '../../../../actions/utility-actions';
import { FlatButton } from '../../../../components/button/FlatButton';
import { DialogHeader } from '../../../../components/dialog/DialogHeader';
import { DialogTrigger } from '../../../../components/dialog/DialogTrigger';
import { ProductionPaperworkDevDocument } from '../../../../models/production/production-paperwork-dev';

export const ProductionRunDevPaperwork = () => {

    const [isOpen, setIsOpen] = React.useState(false);
    const [runId, setRunId] = React.useState("");
    const dispatch = useDispatch();

    /**
     * Handle the dialog open click
     */
    const onOpenClick = () => {
        setIsOpen(true);
    };

    /**
     * Handle the diaog close click
     */
    const onCloseClick = () => {
        setRunId("");
        setIsOpen(false);
    };

    /**
     * Format the dates and initiate the run credit report command
     */
    const runReport = () => {

        const parseResult = Number.parseInt(runId, 10);
        if (!isNaN(parseResult)) {

            const req = new ProductionPaperworkDevDocument(Number(parseResult));
            dispatch(getDocumentHelper(req));
            onCloseClick();
        }
    };

    /**
     * Handler for changing the cutoff date.
     * @param newDate The new cutoff date as chosen 
     */
    const onRunIdChange = (e: any) => {
        setRunId(e.target.value);
    };

    return <React.Fragment>
        <div className="report-card-wrap blue">
            <div className="row">
                <div className="col">
                    <div className="row">
                        <div className="col">
                            <h3>Production Paperwork (Development)</h3>
                            <p>Export production paperwork for a specified run.</p>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col">
                            <DialogTrigger
                                onClick={onOpenClick}
                                text="Run Report" />
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <Dialog
            open={isOpen}
            className="report-dialog"
            onClose={onCloseClick}
            maxWidth="md"
            aria-labelledby="form-dialog-title">

            <DialogHeader>
                <h1>Run Export</h1>
            </DialogHeader>

            <DialogContent>
                <div className="row">
                    <div className="col">
                        <p>Provide a run id to include in the paperwork bundle.</p>
                    </div>
                </div>
                <div className="row justify-content-around">
                    <div className="col">
                        <input
                            id="runId"
                            className="reporting-shipmentexport-textarea"
                            value={runId}
                            onChange={onRunIdChange} />
                    </div>
                </div>
            </DialogContent>
            <DialogActions>
                <FlatButton
                    id="accountmateNoBtn"
                    text="Cancel"
                    classes="negative"
                    onBtnClick={onCloseClick} />
                <FlatButton
                    id="accountmateYesBtn"
                    text="Go"
                    disable={!runId}
                    classes="positive"
                    onBtnClick={runReport} />
            </DialogActions>
        </Dialog>
    </React.Fragment>;

};
